module.exports = __webpack_public_path__ + "img/icon_student_beca.44c8777d.svg";